import {
  webErrorsToIgnore,
  apiErrorsToIgnore,
} from '../constants/errorsToIgnore.js';

const errorsToIgnoreByType = {
  web: webErrorsToIgnore,
  api: apiErrorsToIgnore,
};

export default function createSentryBeforeSend(type, envVarValue) {
  const errorsToIgnore = errorsToIgnoreByType[type];

  return function beforeSend(event, hint) {
    const envValue = envVarValue;
    const isProduction = ['staging', 'production'].includes(envValue);

    if (!isProduction) {
      return null;
    }

    for (const error of errorsToIgnore) {
      if (
        hint.originalException?.name?.includes(error) ||
        hint.originalException?.message?.includes(error) ||
        event.exception?.values?.[0]?.value?.includes(error)
      ) {
        return null;
      }
    }
    return event;
  };
}
